import { CHILD_CODE, INFANT_CODE } from '@/components/booking/types'

export default class AdditionalService {
  constructor ({ Services, Code }, offer) {
    this.services = Services
    this.offer = offer
    this.code = Code
  }

  get data () {
    const selectedServices = this.offer.SelectedServices
      .filter(service => service.ServiceTypeCode == this.code && service.IsVisible)
    
    return {
      code: this.code,
      services: [ ...selectedServices, ...this.services ].map(service => ({
        ...service,
        options: this.getServiceOptions(service),
        selected: false,
        selectedPeople: 0,
        selectedAdults: 0,
        selectedChildren: 0,
        selectedInfants: 0,
        selectedTotalPrice: 0,
        selectedIDs: null,
      })),
    }
  }

  getOptionsForServicePerPerson (service) {
    return [ this.setForAll(service), ...this.setPeople(service) ]
  }

  getOptionsForServicePerReservation (service) {
    return [ this.setForAll(service) ]
  }

  getServiceOptions (service) {
    if (service.IsServicePerPerson) return this.getOptionsForServicePerPerson(service)
    else return this.getOptionsForServicePerReservation(service)
  }

  setForAll (service) {
    return {
      type: 'all',
      title: 'Wszyscy uczestnicy',
      price: service.ServicePriceAll,
      selected: false,
      id: 0,
    }
  }

  setPeople (service) {
    return this.offer.Persons.map(person => {
      if (person.Gender == CHILD_CODE) return this.setChild(person, service)
      else if (person.Gender == INFANT_CODE) return this.setInfant(person, service)
      else return this.setAdult(person, service)
    })
  }

  setAdult (person, service) {
    return {
      type: 'adult',
      title: 'Dorosły',
      price: service.ServicePriceAdult,
      selected: false,
      id: person.Id,
    }
  }

  setChild (person, service) {
    return {
      type: 'child',
      title: 'Dziecko',
      price: service.ServicePriceChild,
      selected: false,
      id: person.Id,
    }
  }

  setInfant (person, service) {
    return {
      type: 'infant',
      title: 'Niemowlę',
      price: service.ServicePriceInfant,
      selected: false,
      id: person.Id,
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/booking/logic/AdditionalService.js